import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import {createStore} from 'vuex-extensions'
import _ from 'lodash'

import {axiosPlugin} from '@/plugins/axios'
import activeCode from './active-code/activeCode.js'
import auth from './app/auth.js'
import user from './app/user.js'
import role from './app/role.js'
import policies from './policies/policies.js'
import layout from './app/layout.js'
import site from './app/site.js'
import cv from './cv/cv.js'
import cvSF from './cv/cv-submit-form.js'
import upload from './other/upload.js'
import notification from './notification/notification.js'
import constant from './other/constant.js'

import lead from './lead/lead.js'
import log from './lead/log.js'
import appointment from './lead/appointment.js'
import product from './lead/product.js'
import exam from './exam/exam.js'
import examRound from './exam/examRound.js'
import subject from './exam/subject.js'
import room from './exam/room.js'
import student from './exam/student.js'
import mark from './exam/mark.js'
import teacher from './teacher/teacher.js'
import teachers from './teacher/teachers.js'
import monitor from './exam/monitor.js'
import roomSubject from './exam/roomSubject.js'
import subjectGroup from './exam/subjectGroup.js'
import examRoom from './exam/examRoom.js'
import indexing from './exam/indexing.js'
import sms from './notification/sms.js'
import email from './notification/email.js'
import pageSettings from './page-settings/pageSettings.js'
import news from './news/news.js'
import studentReview from './student-review/studentReview.js'
import event from './event/event.js'
import ruleConfig from './rule-config/rule-config.js'
import refundForm from './cv/refundForm.js'
import pageSettingRevisions from './page-setting-revisions/pageSettingRevisions.js'
import pageSettingValues from './page-setting-values/pageSettingValues.js'
import missingSD from './missingSD/missingSD.js'
import userAdmin from './app/user-admin.js'
import incentiveReference from './incentive-reference/incentiveReference.js'
import survey from './survey/survey.js'
import studentSurvey from './survey/studentSurvey.js'
import surveyQuestion from './survey/surveyQuestion.js'
Vue.use(Vuex)

export default createStore(Vuex.Store, {
  plugins: [
    createPersistedState({
      key: 'enrollment',
      paths: [
        'auth.user',
        'auth.isAuthenticated',
        'auth.jwt',
        'auth.isConfirmedOTP',
        'auth.role',
        'auth.isRequestingReset'
      ]
    }),
    axiosPlugin
  ],
  modules: {
    auth,
    layout,
    site,
    activeCode,
    cv,
    upload,
    user,
    lead,
    log,
    appointment,
    product,
    notification,
    role,
    policies,
    constant,
    exam,
    examRound,
    student,
    room,
    subject,
    mark,
    teacher,
    teachers,
    monitor,
    roomSubject,
    subjectGroup,
    examRoom,
    indexing,
    sms,
    email,
    pageSettings,
    news,
    studentReview,
    event,
    cvSF,
    ruleConfig,
    refundForm,
    pageSettingRevisions,
    pageSettingValues,
    missingSD,
    userAdmin,
    incentiveReference,
    survey,
    studentSurvey,
    surveyQuestion,
  },
  mixins: {
    mutations: {
      changeState: function(state, changed) {
        Object.entries(changed).forEach(([name, value]) => {
          state[name] = value
        })
      },
      changeDeepState: function(state, changed) {
        Object.entries(changed).forEach(([firstChildName, diff]) => {
          const firstChildValue = {...state[firstChildName]}
          Object.entries(diff).forEach(([path, diffValue]) => {
            _.setWith(firstChildValue, path, diffValue)
          })
          state[firstChildName] = firstChildValue
        })
      }
    }
  }
})
